module.exports = __webpack_public_path__ + "male-avatar.png?61d90d84534b510fcd3778198abef4a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/male-avatar.png
// module id = 599
// module chunks = 0